import * as bootstrap from 'bootstrap';
import AuthService from '../config/auth';
import { ButtonHelper } from './../common/buttonHelper';

let optInChoiceComplete = false;

// --- Registration form validation setup ---
function setupRegisterFormStepOneValidation(): void {
    const $form = $('#RegisterForm');
    const $email = $('#Email');

    if (!$form.length) return;

    const validator = $form.validate({
        ignore: ':hidden',
        messages: {
            Email: {
                remote: 'This email address has already been used. Did you forget your password?'
            }
        },
        rules: {
            Email: {
                required: {
                    depends: () => {
                        $email.val($.trim($email.val() as string));
                        return true;
                    }
                },
                email: true,
                remote: {
                    url: '/Account/IsUsernameAvailable',
                    type: 'POST',
                    async: false,
                    data: {
                        email: () => $email.val()
                    }
                }
            }
        },
        errorPlacement: (error, element) => {
            error.insertAfter(element);
        }
    });

    // Handle form submit
    $form.find('button[type="submit"]').on('click', (e) => {
        e.preventDefault();

        if (validator.form()) {
            (document.getElementById('RegisterForm') as HTMLFormElement).submit();
        } else {
            ButtonHelper.resetSpinnerButtons();
        }
    });
}

function setupRegisterFormStepTwoValidation(): void {
    const $form = $('#AccountSignupForm');
    if (!$form.length) return;

    const $registerButton = $('.btn-account-register');

    // Initialize modal instance
    const confirmOptOutModalEl = document.getElementById('confirmOptOutModal');
    let confirmOptOutModal: bootstrap.Modal | null = null;
    if (confirmOptOutModalEl) {
        confirmOptOutModal = new bootstrap.Modal(confirmOptOutModalEl, {
            backdrop: 'static',
            keyboard: false
        });
    }

    // Click handler for register button
    $registerButton.on('click', (e) => {
        e.preventDefault();

        const validator = $form.validate({
            ignore: ':hidden',
            rules: {
                FirstName: {
                    required: true,
                    alphanumeric: true
                },
                LastName: {
                    required: true,
                    alphanumeric: true
                },
                Password: {
                    required: true,
                    noSpace: true,
                    minlength: 8,
                    passwordCheck: true
                },
                RepeatPassword: {
                    required: true,
                    equalTo: '#Password'
                },
                AcceptsTerms: {
                    required: true
                }
            },
            errorPlacement: (error, element) => {
                // Special placement for checkbox
                if ($(element).attr('id') === 'AcceptsTerms') {
                    const placement = $(element).siblings('.checkbox-placement');
                    if (placement.length) {
                        placement.append(error);
                        return;
                    }
                }
                error.insertAfter(element);
            },
            highlight: (element) => {
                // Highlight checkbox area
                if ($(element).attr('id') === 'AcceptsTerms') {
                    $(element).parent().addClass('checkbox-error');
                }
            },
            unhighlight: (element) => {
                // Remove highlight
                if ($(element).attr('id') === 'AcceptsTerms') {
                    $(element).parent().removeClass('checkbox-error');
                }
            }
        });

        if (validator.form()) {
            // Opt-in confirmation modal logic
            const optedIn = $('#OptedIn').prop('checked');

            if (!optInChoiceComplete && optedIn) {
                optInChoiceComplete = true;
            }

            if (!optInChoiceComplete) {
                confirmOptOutModal?.show();

                // Reset all spinner buttons
                ButtonHelper.resetSpinnerButtons();

                return false;
            }

            (document.getElementById('AccountSignupForm') as HTMLFormElement).submit();
        } else {
            ButtonHelper.resetSpinnerButtons();
        }
    });

    // Confirm opt-in modal handler
    $('.btn-confirm-opt-in').on('click', function (e) {
        optInChoiceComplete = true;

        if ($(this).data('opt-in')) {
            $('#OptedIn').prop('checked', true);
        }

        confirmOptOutModal?.hide();
        $('.btn-account-register').trigger('click');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    AuthService.setupAuthButtons();

    AuthService.setupPasswordToggles();

    setupRegisterFormStepOneValidation();

    setupRegisterFormStepTwoValidation();
});